import { render, staticRenderFns } from "./BpcSidebar.vue?vue&type=template&id=37c814ed&"
import script from "./BpcSidebar.vue?vue&type=script&lang=js&"
export * from "./BpcSidebar.vue?vue&type=script&lang=js&"
import style0 from "./BpcSidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports